<div class="wrapper">
  <div class="title">
    <h4 class="text-xxl text-bold text-center" i18n="front.home.bitoasisFeatures.title">The simple way to buy and sell cryptocurrencies</h4>
    <p class="text-gray text-center" i18n="front.home.bitoasisFeatures.description">Here are a few reasons why you should use BitOasis</p>
  </div>
  <div class="p-3"></div>

  <div class="row align-items-center">
    <div class="col-lg-6">
      <div class="content">
        <div class="steps">
          <a href="javascript: void(0);" class="step" [class.active]="active === 0" (click)="active = 0" i18n="@@front.home.bitoasisFeatures.item1.title">
            <span>01.</span> &nbsp; Trade in your local currency
          </a>
          <a href="javascript: void(0);" class="step" [class.active]="active === 1" (click)="active = 1" i18n="@@front.home.bitoasisFeatures.item2.title">
            <span>02.</span> &nbsp; Largest Coins Offer 
          </a>
          <a href="javascript: void(0);" class="step" [class.active]="active === 2" (click)="active = 2" i18n="@@front.home.bitoasisFeatures.item3.title">
            <span>03.</span> &nbsp; Safe & Secure
          </a>
          <a href="javascript: void(0);" class="step" [class.active]="active === 3" (click)="active = 3" i18n="@@front.home.bitoasisFeatures.item4.title">
            <span>04.</span> &nbsp; Trade from anywhere
          </a>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="images">
        <div class="image" [class.active]="active === 0">
          <img src="assets/images/home/features/trade-local.png" alt="">
          <h4 class="text-bold text-center d-lg-none" i18n="@@front.home.bitoasisFeatures.item1.title"><span>01.</span> &nbsp; Trade in your local currency</h4>
          <p class="text text-center" i18n="front.home.bitoasisFeatures.item1.desciption">Deposit and trade with the <b>UAE dirham (AED)</b> and the <b>Saudi riyal (SAR)</b></p>
        </div><!-- .image -->

        <div class="image" [class.active]="active === 1">
          <img src="assets/images/home/features/coins-offer.png" alt="">
          <h4 class="text-bold text-center d-lg-none" i18n="@@front.home.bitoasisFeatures.item2.title"><span>02.</span> &nbsp; Largest Coins Offer </h4>
          <p class="text text-center" i18n="front.home.bitoasisFeatures.item2.desciption"><b>60+ crypto assets</b>, 200+ trading pairs offered with more to come</p>
        </div><!-- .image -->

        <div class="image" [class.active]="active === 2">
          <img src="assets/images/home/features/safe-secure.png" alt="">
          <h4 class="text-bold text-center d-lg-none" i18n="@@front.home.bitoasisFeatures.item3.title"><span>03.</span> &nbsp; Safe & Secure</h4>
          <p class="text text-center" i18n="front.home.bitoasisFeatures.item3.desciption">We store your crypto assets in <b>cold storage</b> with the world's most secure solution</p>
        </div><!-- .image -->

        <div class="image" [class.active]="active === 3">
          <img src="assets/images/home/features/trade-anywhere.png" alt="">
          <h4 class="text-bold text-center d-lg-none" i18n="@@front.home.bitoasisFeatures.item4.title"><span>04.</span> &nbsp; Trade from anywhere</h4>
          <p class="text text-center" i18n="front.home.bitoasisFeatures.item4.desciption"><b>Invest and trade</b> on the go on our Android and iOS apps</p>
        </div><!-- .image -->
      </div>
    </div>
  </div><!-- .row -->
</div>